import {HTTP} from '@/CallAPI'
export default {
  getListCategory () {
    return HTTP.get('category/checklists')
  },
  createCtg (ctg) {
    return HTTP.post('category/checklists', ctg)
  },
  updateCtg (ctg) {
    return HTTP.put('category/checklists/' + ctg.id, ctg)
  },
  destroyCtg (ctg) {
    return HTTP.delete('category/checklists/' + ctg.id)
  },
  selectCtg (ctg, chks) {
    return HTTP.post('category/checklist/selects', {category: ctg.id, checklist: chks})
  }
}



// WEBPACK FOOTER //
// ./src/service/category-chk.js